import { Helmet } from "react-helmet-async";
import { Footer } from "../../components/Footer";
import { Navbar } from "../../components/Navbar";
import { Container, ContentTable, ContentText, Title } from "./styles";

export const RegulamentoTheBestCopa = () => {
  return (
    <>
      <Helmet>
        <title>Regulamento The Best Copa - Descrição Completa</title>
        <link
          rel="canonical"
          href={`https://thebestacai.com.br/regulamentothebestcopa`}
        />
      </Helmet>
      <Navbar />
      <Container>
        <ContentText>
          <Title>
            Campanha The Best Copa - Condições Gerais do Regulamento
          </Title>
          <p>
            <strong>
              {" "}
              1.1. <u>Objetivo</u>.
            </strong>{" "}
            O presente Regulamento tem por objetivo disciplinar a campanha
            promocional denominada “The Best Copa” (ou “Campanha”), instituída e
            promovida pelo Grupo The Best Franchising Ltda (“Grupo The Best”),
            pessoa jurídica de direito privado, inscrita no CNPJ sob o nº
            28.967.949/0001-84, com sede na Rodovia Engenheiro Ângelo Lopes,
            s/n, sala A, Parque Industrial Nene Favoreto, CEP 86.200-000,
            Ibiporã/PR, com a finalidade de conceder Vouchers aos clientes com
            maior assiduidade de consumo nas lojas da The Best Açaí durante o
            período de 11 de junho de 2026 a 20 de julho de 2026.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              1.2. <u>Abrangência</u>.
            </strong>{" "}
            A Campanha possui âmbito nacional e abrange as lojas físicas da rede
            The Best Açaí que aderirem formalmente à Campanha, conforme critério
            da franqueadora. A relação de lojas participantes estará disponível
            no aplicativo Clube The Best e nos canais oficiais da marca, podendo
            ser atualizada a qualquer momento. A participação de cada unidade
            está sujeita à adesão e ao critério da franqueadora.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              1.3. <u>Vigência</u>.
            </strong>{" "}
            A Campanha será válida no período de{" "}
            <strong> 11 de junho de 2026 a 20 de julho de 2026</strong>, podendo
            ser alterada, suspensa ou encerrada antecipadamente pelo Grupo The
            Best mediante comunicação prévia em seus canais oficiais.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.1. <u>Quem pode participar</u>.
            </strong>{" "}
            Poderão participar da Campanha as pessoas físicas maiores de 18
            (dezoito) anos, devidamente cadastradas no aplicativo do Grupo The
            Best (Clube The Best), com CPF válido e em situação regular, desde
            que observadas todas as condições previstas neste Regulamento.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.2. <u>Impedimentos</u>.
            </strong>{" "}
            Não poderão participar da Campanha os funcionários e colaboradores
            diretos do Grupo The Best, bem como seus respectivos familiares,
            além de quaisquer pessoas que, por sua atuação, possam interferir na
            apuração ou no resultado da Campanha.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.3. <u>Como participar</u>.
            </strong>{" "}
            Para participar, o cliente deverá: (i) dirigir-se a uma loja física
            participante; (ii) informar seu CPF no ato da compra para o
            atendente; e (iii) realizar uma compra mínima de R$ 9,90 (nove reais
            e noventa centavos). Atendidos esses requisitos, a presença será
            registrada automaticamente no Clube The Best para fins de pontuação
            no ranking da respectiva loja.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.4. <u>Presença válida</u>.
            </strong>{" "}
            Cada compra válida gera 1 (um) ponto por participante, por loja, por
            dia. O participante pode pontuar em mais de uma loja no mesmo dia,
            desde que realize uma compra válida em cada estabelecimento,
            contabilizando 1 (um) ponto por loja por dia. A pontuação é apurada
            de forma independente por unidade.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.5. <u>Pontuação múltipla por loja</u>.
            </strong>{" "}
            O participante poderá acumular pontos em diferentes lojas
            participantes em um mesmo dia, respeitado o limite de 1 (um) ponto
            por loja por dia. A pontuação de cada loja é contabilizada de forma
            independente para fins de apuração do respectivo ranking.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              2.6. <u>Condição da compra</u>.
            </strong>{" "}
            Somente serão consideradas para fins de pontuação as compras
            efetivamente concluídas, identificadas com o CPF do participante e
            registradas corretamente no Clube The Best. Compras canceladas,
            estornadas, lançadas em duplicidade ou realizadas em desacordo com
            este Regulamento poderão ser desconsideradas a qualquer tempo.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              3.1. <u>Sistema de pontuação</u>.
            </strong>{" "}
            A pontuação da Campanha será apurada com base no número de presenças
            válidas registradas durante o período de vigência, observados os
            critérios de compra mínima, identificação por CPF e o limite de 1
            (um) ponto por loja por dia por participante.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              3.2. <u>Ranking por loja</u>.
            </strong>{" "}
            Cada loja participante terá apuração própria e independente, de modo
            que o ranking será formado exclusivamente pelas presenças
            registradas naquele ponto de venda. A classificação obtida por um
            participante em determinada loja não se comunica com o ranking de
            outra unidade. Não há ranking global entre lojas.
          </p>
          <br />
          <p>
            <strong>
              {" "}
              3.3. <u>Apuração por loja</u>.
            </strong>{" "}
            A apuração é realizada de forma independente por loja participante.
            A pontuação acumulada em uma unidade não se soma à de outra para
            fins de premiação. Não há ranking global entre lojas.
          </p>
          <br />
          <p>
            <strong>
              3.4. <u>Acompanhamento e divulgação</u>.
            </strong>{" "}
            O acompanhamento da Campanha, quando disponibilizado, poderá ocorrer
            por meio do aplicativo Clube The Best, canais oficiais do Grupo The
            Best, materiais de divulgação nas lojas e/ou outros meios por ela
            eleitos. A divulgação de rankings parciais, comunicados e resultados
            observará os dados constantes no aplicativo Clube The Best, os quais
            prevalecerão para fins de apuração.
          </p>
          <br />
          <p>
            <strong>
              3.5. <u>Critérios de desempate</u>.
            </strong>{" "}
            Em caso de empate na pontuação final no ranking de cada loja, serão
            adotados, sucessivamente, os seguintes critérios: (i) maior valor
            total gasto pelo participante durante o período da Campanha; (ii)
            maior tempo de cadastro no aplicativo Clube The Best; e (iii) maior
            total de pontos acumulados pelo participante no aplicativo Clube The
            Best durante o período da Campanha.
          </p>
          <br />
          <p>
            <strong>
              3.6. <u>Auditoria e validação</u>.
            </strong>{" "}
            Para garantir a regularidade da Campanha, o Grupo The Best poderá, a
            qualquer tempo, auditar informações cadastrais, registros de compra,
            pontuação, dados de CPF e demais elementos relacionados à
            participação. Caso sejam identificadas inconsistências, suspeitas de
            fraude, duplicidade de registros, erro sistêmico ou descumprimento
            deste Regulamento, o Grupo The Best poderá ajustar a pontuação,
            invalidar registros ou promover a desclassificação do participante,
            conforme o caso.
          </p>
          <br />
          <p>
            <strong>
              4.1. <u>Resgate de Voucher por loja</u>.
            </strong>{" "}
            Ao final da Campanha, sujeito à disponibilidade de estoque, os 3
            (três) participantes mais bem classificados no ranking final de cada
            loja participante poderão receber um Voucher que dará direito ao
            resgate de produtos personalizados da Campanha, conforme divulgação
            oficial da marca, da seguinte forma:
          </p>
          <br />
          <ContentTable>
            <thead>
              <tr>
                <th>Classificação</th>
                <th>Voucher</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table_td">1º Lugar</td>
                <td>
                  Voucher Ouro: Direito de resgate a 1 bola oficial da Campanha
                  (sujeita à disponibilidade em loja) + 10 (dez) vales de R$
                  30,00 (trinta reais) cada.
                </td>
              </tr>

              <tr>
                <td className="table_td">2º Lugar</td>
                <td>
                  Voucher Prata: Direito de resgate a 1 bola oficial da Campanha
                  (sujeita à disponibilidade em loja) + 05 (cinco) vales de R$
                  30,00 (trinta reais) cada.
                </td>
              </tr>

              <tr>
                <td className="table_td">3º Lugar</td>
                <td>
                  Voucher Bronze: Direito de resgate a 1 bola oficial da
                  Campanha (sujeita à disponibilidade em loja) + 02 (dois) vales
                  de R$ 30,00 (trinta reais) cada.
                </td>
              </tr>
            </tbody>
          </ContentTable>
          <br />
          <p>
            <strong>
              4.2. <u>Entrega dos Vouchers</u>.
            </strong>{" "}
            Os vencedores serão contatados pelos canais oficiais do Grupo The
            Best para orientações sobre a retirada do voucher, mediante
            apresentação de documento oficial com foto e CPF. A entrega está
            condicionada à disponibilidade do item e ao cumprimento das regras
            da Campanha.
          </p>
          <br />
          <p>
            <strong>
              4.3. <u>Condições da premiação</u>.
            </strong>{" "}
            Os Vouchers são pessoais e intransferíveis, não poderão ser
            convertidos em dinheiro, trocados por outros produtos ou cedidos a
            terceiros, salvo se o Grupo The Best deliberar de forma diversa por
            escrito. As imagens eventualmente utilizadas em materiais de
            divulgação são meramente ilustrativas, podendo haver alteração de
            modelo, cor, embalagem ou especificações dos itens, sem prejuízo da
            equivalência da premiação anunciada.
          </p>
          <br />
          <p>
            <strong>
              4.4. <u>Prazo para retirada</u>.
            </strong>{" "}
            Caso o Grupo The Best estabeleça prazo para retirada ou recebimento
            dos Vouchers, o participante deverá observá-lo integralmente. A
            ausência de manifestação ou de retirada no prazo informado poderá
            ser interpretada como renúncia ao Vouchers, hipótese em que o Grupo
            The Best poderá adotar a destinação interna cabível, sem gerar
            qualquer indenização ao participante.
          </p>
          <br />
          <p>
            <strong>
              5.1. <u>Desclassificação</u>.
            </strong>{" "}
            Será imediatamente desclassificado o participante que: (i) informar
            dado pessoal incorreto, falso, incompleto ou de terceiro sem
            autorização; (ii) utilizar meios ilícitos, fraudulentos ou não
            previstos neste Regulamento para obter pontuação; (iii) tentar
            manipular registros de compra, CPF, presença ou ranking; (iv)
            praticar conduta que atente contra a boa-fé, a ética, a imagem da
            marca ou os objetivos da Campanha; ou (v) descumprir quaisquer das
            condições estabelecidas neste Regulamento.
          </p>
          <br />
          <p>
            <strong>
              5.2. <u>Desconsideração de registros</u>.
            </strong>{" "}
            O Grupo The Best poderá inutilizar ou desconsiderar qualquer
            registro de compra, pontuação ou presença que apresente indícios de
            reprodução, adulteração, inconsistência, defeito, vício ou qualquer
            elemento que impeça a verificação de sua autenticidade ou
            regularidade.
          </p>
          <br />
          <p>
            <strong>
              5.3. <u>Responsabilidade do participante</u>.
            </strong>{" "}
            O participante é o único responsável pela veracidade das informações
            prestadas, pela atualização de seus dados cadastrais e pela
            observância das regras da Campanha. O Grupo The Best não se
            responsabiliza por falhas decorrentes de informações incorretas,
            incompletas ou desatualizadas fornecidas pelo participante.
          </p>
          <br />
          <p>
            <strong>
              5.4. <u>Falhas técnicas</u>.
            </strong>{" "}
            O Grupo The Best não se responsabiliza por eventuais falhas
            técnicas, instabilidades de sistema, indisponibilidade temporária do
            aplicativo, problemas de conectividade, integração entre sistemas ou
            outros eventos tecnológicos que possam, momentaneamente, dificultar
            o registro ou a visualização de dados da Campanha, não sendo tais
            hipóteses motivo para cancelamento, prorrogação ou alteração
            automática do período de vigência.
          </p>
          <br />
          <p>
            <strong>
              5.5. <u>Proteção de dados</u>.
            </strong>{" "}
            Os dados pessoais tratados no âmbito desta Campanha serão utilizados
            para viabilizar a participação, registrar pontuação, realizar a
            apuração, comunicar resultados, entregar Vouchers, e atender
            obrigações legais e regulatórias aplicáveis, em conformidade com a
            Lei nº 13.709/2018 (LGPD) e com as políticas de privacidade do Grupo
            The Best, presentes em seu site institucional. Ao participar da
            Campanha, o participante declara ciência de que seus dados poderão
            ser tratados para tais finalidades.
          </p>
          <br />
          <p>
            <strong>
              5.6. <u>Uso de imagem e nome</u>.
            </strong>{" "}
            Ao participar da Campanha e na hipótese de ser declarado vencedor, o
            participante autoriza, desde já, de forma gratuita, irrevogável e
            irretratável, o uso de seu nome, imagem e voz pelo Grupo The Best,
            pelo prazo de 60 (sessenta) meses, contados da data de divulgação do
            resultado final da Campanha, em todo o território nacional e no
            exterior, para fins de divulgação institucional, publicitária e
            promocional relacionados à Campanha e à marca, em quaisquer meios de
            comunicação, físicos ou digitais, sem que isso gere ao vencedor
            qualquer direito a indenização, remuneração ou compensação
            adicional, observada a legislação aplicável.
          </p>
          <br />
          <p>
            <strong>
              5.7. <u>Alterações e cancelamento</u>.
            </strong>{" "}
            O Grupo The Best reserva-se o direito de alterar, suspender ou
            cancelar a Campanha, total ou parcialmente, a qualquer tempo,
            mediante comunicação prévia em seus canais oficiais, especialmente
            em caso de força maior, fraude, determinação legal, inviabilidade
            operacional ou necessidade de ajuste do programa promocional.
          </p>
          <br />
          <p>
            <strong>
              5.8. <u>Aceitação do Regulamento</u>.
            </strong>{" "}
            A participação na Campanha implica ciência, compreensão e aceitação
            integral deste Regulamento e das decisões do Grupo The Best sobre os
            casos omissos, observados os limites da legislação aplicável.
          </p>
          <br />
          <p>
            <strong>
              5.9. <u>Canais de atendimento</u>.
            </strong>{" "}
            Em caso de dúvidas, solicitações ou questionamentos relacionados à
            Campanha, o participante poderá utilizar os canais oficiais de
            atendimento disponibilizados no aplicativo, no site oficial ou nos
            meios de comunicação divulgados pela Promotora.
          </p>
          <br />
          <p>
            <strong>
              5.10. <u>Foro</u>.
            </strong>{" "}
            Fica eleito o Foro da Comarca de Londrina, Estado do Paraná, para
            dirimir quaisquer controvérsias oriundas deste Regulamento, com
            renúncia expressa a qualquer outro, por mais privilegiado que seja.
          </p>
          <br />
          <div className="franchising">
            <h2>GRUPO THE BEST FRANCHISING LTDA</h2>
            <p>28.967.949/0001-84</p>
          </div>
          <div className="update">
            <p>Última atualização: 02 de junho de 2026.</p>
          </div>
        </ContentText>
      </Container>
      <Footer />
    </>
  );
};
